export enum CurrencySymbol {
  usd = '$',
  inr = '₹',
  eur = '€',
}

export default CurrencySymbol;
